import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const WarningIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="none"
    fill="currentColor"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.6666 9.00024c.4142 0 .75.33578.75.75v3.74996c0 .4143-.3358.75-.75.75s-.75-.3357-.75-.75V9.75024c0-.41422.3358-.75.75-.75Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5426 2.55233c.3415-.19804.7292-.30233 1.124-.30233.3948 0 .7825.10429 1.124.30233.3409.19769.6237.4818.8197.82365l.001.00174 8.2481 14.24678c.1972.3414.3016.7295.3019 1.1238.0004.3942-.1029.7817-.2995 1.1235-.1965.3418-.4794.626-.8203.824-.341.1981-.728.303-1.1223.3044H4.41395c-.39428-.0014-.78128-.1063-1.12222-.3044-.34094-.198-.62385-.4822-.82039-.824-.19654-.3418-.29981-.7293-.29946-1.1235.00035-.3943.1043-.7816.30145-1.1231L10.7219 3.37772l.001-.00183c.1961-.34181.4788-.62589.8197-.82356Zm-.1698 1.19789.6491.37579L3.77236 18.3752c-.0656.1138-.10037.2431-.10048.3744-.00012.1314.0343.2606.09982.3745.06551.1139.15981.2087.27346.2747.11338.0658.24204.1008.37315.1014H20.9149c.1311-.0006.2597-.0356.3731-.1014.1137-.066.208-.1608.2735-.2747.0655-.1139.0999-.2431.0998-.3745-.0001-.1314-.0348-.2605-.1005-.3744L13.3094 4.12276c-.0648-.11325-.1584-.20737-.2713-.27283-.1129-.06546-.241-.09993-.3715-.09993s-.2587.03447-.3715.09993c-.1129.06546-.2065.15958-.2713.27283l-.651-.37254Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="M12.6666 18.0002c.6213 0 1.125-.5036 1.125-1.125 0-.6213-.5037-1.125-1.125-1.125s-1.125.5037-1.125 1.125c0 .6214.5037 1.125 1.125 1.125Z"
      fill="currentColor"
      stroke="none"
    />
  </SvgIcon>
);

export default WarningIcon;
